"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COUNT_DOWN_DATE_TIMER_LAYOUT = exports.COUNT_DOWN_DATE_TIMER_THEME = exports.COUNT_DOWN_DATE_TIMER_POSITION = void 0;
exports.COUNT_DOWN_DATE_TIMER_POSITION = {
    CENTER: 'center',
    LEFT: 'left',
    RIGHT: 'right',
};
exports.COUNT_DOWN_DATE_TIMER_THEME = {
    PURPLE: 'purple',
    PURPLE_REVERSE: 'purple-reverse',
    WHITE: 'white',
    BLUE: 'blue',
    BLUE_REVERSE: 'blue-reverse',
    BLUE_DARK: 'blue-dark',
};
exports.COUNT_DOWN_DATE_TIMER_LAYOUT = {
    COMPACT: 'compact',
    BAND: 'band',
};
//# sourceMappingURL=enums.js.map